import { render, staticRenderFns } from "./SexHeader.vue?vue&type=template&id=4ab5ccfe&"
import script from "./SexHeader.vue?vue&type=script&lang=js&"
export * from "./SexHeader.vue?vue&type=script&lang=js&"
import style0 from "./SexHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports